import apiHandler from '../../utilities/apiHandler.js';

const InwardingApiHandler = {

	getAllVendors: function () {
		return apiHandler.get('inwarding/vendors/lite/active');
	},

	getInvoiceBySearch: function (vendorId, invoiceNumber) {
		return apiHandler.get('inwarding/get-invoices-for-vendorId-and-number?vendorId=' + vendorId + '&vendorInvoiceNumber=' + invoiceNumber);
	},

	getProductsForVendorInvoice: function (vendorInvoiceId) {
		return apiHandler.get('inwarding/get-products-associated-with-vendorinvoice?vendorInvoiceId=' + vendorInvoiceId);
	},

	getProductsAddedToPallet: function (vendorInvoiceId) {
		return apiHandler.get('inwarding/get-products-already-received?vendorInvoiceId=' + vendorInvoiceId);
	},

	getSpaceByBarcode: function (barcode) {
		return apiHandler.get('space/get-space-by-barcode?barcode=' + barcode);
	},

	getAllListingsForJPIN: function (listingId) {
		return apiHandler.get('inwarding/return-alternate-listings?listingId=' + listingId);
	},

	uploadPod: function (req) {
		const URL = 'v2/inwarding/vendor-invoice/add-pod';
		return apiHandler.post(URL, req);
		
	},

	getInoiceDeatilsById: function (vinv) {
		return apiHandler.get('inwarding/get/vendorinvoice?vendorInvoiceId=' + vinv);
	},

	createNewListing: function (req) {
		return apiHandler.post('inwarding/create/listing', req);
	},

	addToPallet: function (req) {
		return apiHandler.post('inwarding/receive-goods', req);
	},

	fetchPalletInfo: function (vinv) {
		return apiHandler.get('inwarding/create-or-get-container?vendorInvoiceId=' + vinv);
	},

	getPODDetails: function (orderId) {
		return apiHandler.get("inwarding/rpo?orderId=" + orderId);
	},

	createInwardingDocument: function (request) {
		const URL = "v2/inwarding/inwarding-document/create";
		return apiHandler.post(URL, request);
	},

	dropPallet: function (request) {
		return apiHandler.post("inwarding/drop-pallet", request);
	},

	fetchAlreadyInwardedProducts: function (vinv) {
		return apiHandler.get("inwarding/inwarded/items?vendorInvoiceId=" + vinv);
	},

	searchBarCode: function (barcode) {
		return apiHandler.get("product/fetch-all-skus/for-label-code?labelCode=" + barcode);
	},

	searchAllBarCode: function(barcode){
		return apiHandler.get("product/fetchAll/for-label-code?labelCode=" + barcode)
	},

	uploadToS3: function (formData) {
		return apiHandler.postIngestion("inwarding/upload", formData);
	},

	AddMoreQuantityApi: function (vinv, lst) {
		return apiHandler.get(`inwarding/goods-received-item?vendorInvoiceId=${vinv}&listingId=${lst}`);
	},

	searchProductFromTitle: function (title) {
		return apiHandler.get(`product/suggest/v1?title=${title}`);
	},

	callParentListingApi: function (vinv) {
		return apiHandler.get(`inwarding/products-associated-with-freebie?vendorInvoiceId=${vinv}`);
	},

	callFreebielistingApi: function (jpin, vinv) {
		return apiHandler.get(`inwarding/listings/${jpin}/${vinv}`);
	},

	checkAllFreebiesInwarded: function (req) {
		return apiHandler.post('inwarding/upload-pod/check-freebie', req);
	}

}

export default InwardingApiHandler;


// WEBPACK FOOTER //
// ./src/screens/Inwarding/InwardingApiHandler.js